import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M1.668 2.5h16.667m-.834 0v9.167a1.667 1.667 0 0 1-1.666 1.666H4.168a1.667 1.667 0 0 1-1.667-1.666V2.5m3.334 15L10 13.333l4.167 4.167"
    }, null, -1)
  ]))]))
}
export default { render: render }